module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/42bede21a59051341e756d2ae3f64723.svg";